import React from 'react';
import { CategoriesHeader } from 'kards-components';
import { useReadContext } from 'src/modules/card/context';
import { useTheme } from 'src/modules/card/context/theme';

const CategoryList = () => {
  const { cardData, setCurrentCategory, currentCategory }: any = useReadContext();
  const theme = useTheme();

  return (
    <CategoriesHeader
      theme={theme}
      currentCategory={currentCategory}
      setCurrentCategory={setCurrentCategory}
      data={cardData}
    />
  );
};

export default CategoryList;
